import getConfig from 'next/config';

interface ConfigType {
  environment: 'PRODUCTION' | 'DEVELOPMENT' | 'LOCAL';
  baseApiUrl: string;
  baseUrl: string;
  baseImageUrl: string;
  reCaptchaKey: string;
  yandexMapsKey: string;
  apiToken: string;
  isDebug: string;
  tagManagerId: string;
  baseDomain: string;
  yaPayMerchantId: string;
  yaPaySandbox: boolean;
  yandexCaptchaKey?: string;
  aplautStoreId: string;
  metrikaClientID: string;
  defaultMailPickUpInStore: string;
  isShowYellowSlots: boolean;
  isCookiesYellowSlots: boolean;
  safeModeWidget: string;
  safeModeActionsByCartProduct: string;
  safeModeFitsTheCarByCartProduct: string;
  safeModeAnaloguesByCartProduct: string;
  safeModeSubscription: string;
  safeModeLK: string[];
  safeModeCatalogOffAvailability: boolean;
  safeModeFilterOnlyMainParam: boolean;
  safeModeSelectionByCar: boolean;
  uuidWidget: string;
  urlWidget: string;
  apiWidgetToken: string;
  baseApiUrlWidget: string;
  openReplayDomain: string;
  openReplayKey: string;
  openReplayOn: boolean;
  waitFetch: number;
}

const config: Readonly<ConfigType> = {
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT as 'PRODUCTION' | 'DEVELOPMENT' | 'LOCAL',
  baseApiUrl: process.env.NEXT_PUBLIC_API_URL,
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL || 'https://koleso.ru',
  baseImageUrl: 'https://koleso.ru',
  reCaptchaKey: process.env.NEXT_PUBLIC_RECAPTCHA_KEY,
  yandexMapsKey: process.env.NEXT_PUBLIC_YANDEX_MAPS_KEY,
  yandexCaptchaKey: process.env.NEXT_PUBLIC_YANDEX_CAPTCHA_KEY,
  apiToken: process.env.NEXT_PUBLIC_TOKEN,
  isDebug: process.env.NEXT_PUBLIC_DEBUG,
  tagManagerId: 'GTM-KFPHZ6',
  baseDomain: process.env.NEXT_PUBLIC_BASE_DOMAIN || '.koleso.ru',
  yaPayMerchantId: process.env.NEXT_PUBLIC_YAPAY_MERCHANTID,
  yaPaySandbox: process.env.NEXT_PUBLIC_YAPAY_SANDBOX !== 'false',
  aplautStoreId: process.env.NEXT_PUBLIC_APLAUT_STORE_ID,
  metrikaClientID: process.env.NEXT_PUBLIC_YANDEX_METRIKA,
  defaultMailPickUpInStore: 'pick-up-in-store-koleso@koleso.ru',

  isShowYellowSlots: false,
  isCookiesYellowSlots: true,

  // safeMode
  safeModeWidget: getConfig()?.publicRuntimeConfig?.WIDGET_SAFE_MODE,
  safeModeActionsByCartProduct: getConfig()?.publicRuntimeConfig?.ACTIONS_BY_CART_PRODUCT_SAFE_MODE,
  safeModeFitsTheCarByCartProduct: getConfig()?.publicRuntimeConfig?.FITS_THE_CAR_BY_CART_PRODUCT_SAFE_MODE,
  safeModeAnaloguesByCartProduct: getConfig()?.publicRuntimeConfig?.ANALOGUES_BY_CART_PRODUCT_SAFE_MODE,
  safeModeSubscription: getConfig()?.publicRuntimeConfig?.SUBSCRIPTION_SAFE_MODE,
  safeModeLK: getConfig()?.publicRuntimeConfig?.LK_SAFE_MODE,
  safeModeCatalogOffAvailability: getConfig()?.publicRuntimeConfig?.CATALOG_OFF_AVAILABILITY_SAFE_MODE || false,
  safeModeFilterOnlyMainParam: getConfig()?.publicRuntimeConfig?.FILTER_ONLY_MAIN_PARAM_SAFE_MODE || false,
  safeModeSelectionByCar: getConfig()?.publicRuntimeConfig?.SELECTION_BY_CAR_SAFE_MODE || false,

  // переменные для виджета шиномонтажа
  uuidWidget: process.env.NEXT_PUBLIC_WIDGET_UUID,
  urlWidget: process.env.NEXT_PUBLIC_WIDGET_URL,
  apiWidgetToken: process.env.NEXT_PUBLIC_WIDGET_TOKEN || '3|pLAZ0b7fVu4QdQOltdpyhRnkrPznkKKful8QoI9x',
  baseApiUrlWidget: process.env.NEXT_PUBLIC_API_WIDGET_URL,

  // переменные для openReplay
  openReplayDomain: process.env.NEXT_PUBLIC_OPEN_REPLAY_DOMAIN,
  openReplayKey: process.env.NEXT_PUBLIC_OPEN_REPLAY_KEY,
  openReplayOn: getConfig()?.publicRuntimeConfig.OPEN_REPLAY_ON,

  waitFetch: parseInt(process.env.MAX_API_WAIT_TIME) || 5000,
};

if (config.isDebug) {
  console.log('config', config, process.env);
}

export default config;
